import { api } from './api';
import type {
  ApiResponse,
  AuthResponse,
  LoginCredentials,
  RegisterPayload,
  UserTeam,
} from '../utils/types';

export class AuthService {
  async login(credentials: LoginCredentials): Promise<ApiResponse<AuthResponse>> {
    const response = await api.post('/auth/login', credentials);
    return response.data;
  }

  async register(data: RegisterPayload): Promise<ApiResponse<AuthResponse>> {
    const response = await api.post('/auth/register', data);
    return response.data;
  }

  async logout(): Promise<ApiResponse> {
    const response = await api.post('/auth/logout');
    return response.data;
  }

  async refreshToken(refreshToken: string): Promise<ApiResponse<{ accessToken: string; refreshToken: string }>> {
    const response = await api.post('/auth/refresh', { refreshToken });
    return response.data;
  }

  async forgotPassword(email: string): Promise<ApiResponse> {
    const response = await api.post('/auth/forgot-password', { email });
    return response.data;
  }

  async resetPassword(token: string, password: string): Promise<ApiResponse> {
    const response = await api.post('/auth/reset-password', {
      token,
      password
    });
    return response.data;
  }

  async getCurrentUser(): Promise<ApiResponse<{ user: any; team: any }>> {
    const response = await api.get('/auth/me');
    return response.data;
  }

  async verifyEmail(token: string): Promise<ApiResponse> {
    const response = await api.post('/auth/verify-email', { token });
    return response.data;
  }

  async resendVerificationEmail(): Promise<ApiResponse> {
    const response = await api.post('/auth/resend-verification');
    return response.data;
  }
  async getUserTeams(): Promise<ApiResponse<UserTeam[]>> {
    const response = await api.get('/auth/teams');
    return response.data;
  }
  async switchTeam(teamId: string): Promise<ApiResponse<AuthResponse>> {
    const response = await api.post('/auth/switch-team', { teamId });
    return response.data;
  }
}

export const authService = new AuthService();